import { render, staticRenderFns } from "./MealsWeekListEmpty.vue?vue&type=template&id=05095717"
import script from "./MealsWeekListEmpty.vue?vue&type=script&lang=js"
export * from "./MealsWeekListEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports